import React, { Fragment, useMemo, useState } from "react";
import { ModelCompareWithButtonGroup } from "pages/LayoutComponents/ModelCompareWithButtonGroup";
import { ModelCompareTab } from "pages/Sections/GettingStartedWithUniFi/GettingStartedWithUniFi.types";
import {
  DoorAccessGroupId,
  doorAccessSections,
  doorAccessTabs,
} from "pages/Sections/CameraSecurity/DoorAccess/ModelCompare.config";
import { ProductListGroupId } from "constants/modelCompareData/types";
import { Section } from "constants/modelCompareData/types";
import { StyledContainer } from "components/StyledContainer";
import { ExtendedTabs } from "components/ExtendedTabs/ExtendedTabs";
import { IExtendedTab } from "components/ExtendedTabs/ExtendedTabs.types";

export const CompareBlock = ({
  compareTabs,
  compareOptions,
  showBuyButton,
}: Readonly<{
  compareTabs: Array<IExtendedTab>;
  compareOptions: Record<ModelCompareTab, Section | null>;
  showBuyButton: boolean;
}>) => {
  const [selectedCompareId, setSelectedCompareId] = useState(
    ModelCompareTab.Switching,
  );

  const [doorAccessCompareSelectedTabId, setDoorAccessCompareSelectedTabId] =
    useState<DoorAccessGroupId>(ProductListGroupId.DoorAccessStarterKits);

  const selectedCompareSection = useMemo(
    () => compareOptions[selectedCompareId],
    [compareOptions, selectedCompareId],
  );

  const selectedTab = useMemo(
    () => doorAccessTabs[doorAccessCompareSelectedTabId],
    [doorAccessCompareSelectedTabId],
  );

  const selectedTable = useMemo(
    () => doorAccessSections[selectedTab.id],
    [selectedTab.id],
  );

  const handleTabSelect = (id: DoorAccessGroupId) =>
    setDoorAccessCompareSelectedTabId(id);

  return (
    <Fragment>
      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 40, bottom: 0 }}
      >
        <ExtendedTabs
          tabs={compareTabs}
          activeTabId={selectedCompareId}
          onSelectTab={(tab) => {
            setSelectedCompareId(tab.id as ModelCompareTab);
          }}
        />
      </StyledContainer>

      <StyledContainer
        size="desktop"
        noVerticalMargin
        $spacing={{ top: 24, bottom: 32 }}
      >
        <ModelCompareWithButtonGroup
          tabItems={
            selectedCompareId === ModelCompareTab.DoorAccess
              ? Object.values(doorAccessTabs)
              : []
          }
          onTabClick={handleTabSelect}
          activeTab={doorAccessCompareSelectedTabId}
          section={
            selectedCompareId === ModelCompareTab.DoorAccess
              ? selectedTable
              : selectedCompareSection
          }
          showBuyButton={showBuyButton}
        />
      </StyledContainer>
    </Fragment>
  );
};
